<app-itopia-loader *ngIf="loading"></app-itopia-loader>
<router-outlet *ngIf="!loading"></router-outlet>
